__webpack_require__.p = "/wp-content/themes/1ou2cocktails/dist/";